(function () {
  'use strict';

  function parseTargets(value) {
    return (value || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
      .map(function (pair) {
        var bits = pair.split(':');
        return { id: bits.shift().trim(), selector: bits.join(':').trim() || null };
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' -> ' + res.status);
      return res.json();
    });
  }

  function findLive(id) {
    return document.getElementById('shopify-section-' + id) || document.getElementById(id);
  }

  function applySections(data, targets) {
    if (!data || !data.sections) return false;

    var parser = new DOMParser();
    var applied = false;

    targets.forEach(function (target) {
      var html = data.sections[target.id];
      if (!html) return;

      var live = findLive(target.id);
      if (!live) return;

      var doc = parser.parseFromString(html, 'text/html');
      var root = doc.getElementById('shopify-section-' + target.id) || doc.body;

      if (target.selector) {
        var src = root.querySelector(target.selector);
        var dest = live.querySelector(target.selector);
        if (!src || !dest) return;
        dest.innerHTML = src.innerHTML;
      } else {
        live.innerHTML = root.innerHTML;
      }

      applied = true;
    });

    return applied;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fnd-cart-action]');
    if (!btn || btn.disabled) return;

    event.preventDefault();

    var wrapper = btn.closest('[data-fnd-cart-refresh]');
    var targets = parseTargets(wrapper && wrapper.dataset.fndCartRefresh);
    var sectionIds = targets.map(function (t) { return t.id; }).join(',');

    var action = btn.dataset.fndCartAction;
    var removeKey = btn.dataset.fndRemoveKey;
    var addVariant = Number(btn.dataset.fndAddVariant);
    var addQuantity = Number(btn.dataset.fndAddQuantity) || 1;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var sectionArgs = sectionIds
      ? { sections: sectionIds, sections_url: window.location.pathname }
      : {};

    var chain = Promise.resolve();

    if (removeKey) {
      chain = chain.then(function () {
        return post('/cart/change.js', Object.assign(
          { id: removeKey, quantity: 0 },
          action === 'swap' ? {} : sectionArgs
        ));
      });
    }

    if (action === 'swap' && addVariant) {
      chain = chain.then(function () {
        return post('/cart/add.js', Object.assign(
          { items: [{ id: addVariant, quantity: addQuantity }] },
          sectionArgs
        ));
      });
    }

    chain
      .then(function (data) {
        if (!applySections(data, targets)) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('fnd:cart-updated', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[cart-warnings]', err);
        window.location.href = '/cart';
      });
  });
})();